function isJwtToken(token) {
  if (typeof token !== "string") {
    return false;
  }

  const parts = token.split(".");
  if (parts.length !== 3) {
    return false;
  }

  return parts.every((part) => part.length > 0);
}

function buildBearerAuthorization(token) {
  return isJwtToken(token) ? `Bearer ${token}` : null;
}

function shouldTriggerAuthRecovery(token, recoveryInProgress) {
  return !isJwtToken(token) && !recoveryInProgress;
}

module.exports = {
  isJwtToken,
  buildBearerAuthorization,
  shouldTriggerAuthRecovery,
};
